import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { userListHeaderStyles } from "@insite/content-library/Widgets/UserList/UserListHeader";

import { css } from "styled-components";

userListHeaderStyles.wrapper = mergeToNew(userListHeaderStyles.wrapper, {
    css: css`
        margin-bottom: 1rem;
        max-width: 100% !important;
    `,
});

userListHeaderStyles.searchGridItem = mergeToNew(userListHeaderStyles.searchGridItem, {
    width: [12, 12, 6, 6, 6],
});

userListHeaderStyles.searchTextField = mergeToNew(userListHeaderStyles.searchTextField, {
    cssOverrides: {
        inputSelect: css`
            padding-right: 35px;
        `,
    },
});
